import React from 'react';

import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
    bonusTooltip: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: '1px solid #E3E3FA',
        borderRadius: '8px',
        color: '#1F2152',
        fontSize: '16px',
        fontWeight: 300,
        margin: '0px 4px',
        padding: '12px !important',
        width: 'fit-content',
        '& i': {
            color: '#7378E8',
            fontSize: '24px',
            marginRight: '10px'
        }
    }
}));

type InfoProps = {
    limit?: number;
    message?: string;
    name?: string;
    used?: number;
};

function getLongMonthName() {
    const today = new Date();
    const nextMonth = new Date(today);

    nextMonth.setMonth(today.getMonth() + 1);

    if (nextMonth.getMonth() !== (today.getMonth() + 1) % 12) {
        nextMonth.setFullYear(today.getFullYear(), today.getMonth() + 1);
    }

    return nextMonth.toLocaleString('default', { month: 'long' });
}

const Info: React.FC<InfoProps> = ({ limit = 0, message, name, used = 0 }) => {
    const classes = useStyles();
    const remaining = limit - used;

    if (!message && remaining > 0) {
        return null;
    }

    const possessiveSuffix = name
        ? name.endsWith('s') || name.endsWith('S')
            ? `${name}'`
            : `${name}'s`
        : `member's`;

    return (
        <span className={classes.bonusTooltip}>
            <i className="fas fa-info-circle" />
            {message ??
                `${possessiveSuffix} bonus pool will refresh in ${getLongMonthName()}!`}
        </span>
    );
};

export default Info;
